import { render } from "./ProspectsGeography.vue?vue&type=template&id=a7caf538"
import script from "./ProspectsGeography.vue?vue&type=script&lang=js"
export * from "./ProspectsGeography.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\aflem\\Desktop\\Analyze\\TRANSFER\\clientell\\static\\assets\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__